import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILocumJobs } from '../../models/dashboard/jobs/getLocumJobs.model';

interface ILocumJobsState {
  page: number;              // current page number (you pass this in the request)
  perPage: number;           // items per page (also passed in the request)
  totalPages: number;        // total pages as returned by the API
  totalElements: number;     // total number of jobs
  numberOfElements: number;  // number of jobs in the current page
  first: boolean;            // is this the first page
  last: boolean;             // is this the last page
  jobData: ILocumJobs[];     // job objects (mapped from the "content" field)
}

const initialState: ILocumJobsState = {
  page: 1,
  perPage: 10,
  totalPages: 0,
  totalElements: 0,
  numberOfElements: 0,
  first: true,
  last: true,
  jobData: [],
};

interface ILocumJobsResponsePayload {
  page: number;              // current page (should be included in your API request response, if not, pass it along manually)
  perPage: number;           // same for perPage
  totalPages: number;
  totalElements: number;
  numberOfElements: number;
  first: boolean;
  last: boolean;
  content: ILocumJobs[];     // the jobs array from your API response
}

const locumJobsSlice = createSlice({
  name: 'locumJobs',
  initialState,
  reducers: {
    updateLocumJobs(state, action: PayloadAction<ILocumJobsResponsePayload>) {
      state.page = action.payload.page;
      state.perPage = action.payload.perPage;
      state.totalPages = action.payload.totalPages;
      state.totalElements = action.payload.totalElements;
      state.numberOfElements = action.payload.numberOfElements;
      state.first = action.payload.first;
      state.last = action.payload.last;
      state.jobData = action.payload.content;
    },
  },
});

export const locumJobsActions = locumJobsSlice.actions;
export default locumJobsSlice.reducer;
